import { Usuario } from "./usuario";

export class Session {
    public ususario: Usuario;
    public perfil: string;
    public fecha : Date;
    constructor(){
        this.ususario = null;
        this.perfil = "";
        this.fecha = new Date();
    }
}